import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';
import { ILocation } from '../../../../shared/components/location-modal/location-modal.interfaces';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';

@Component({
  selector: 'app-task-client-address-sel',
  templateUrl: './task-client-address-sel.component.html',
  styleUrls: ['./task-client-address-sel.component.css']
})
export class TaskClientAddressSelComponent implements OnInit {
  dialog: MatDialogRef<any>;
  loading: boolean = false;
  addresses: ILocation[] = [];

  constructor(
    public dialogRef: MatDialogRef<any>,
    private _dialogService: DialogService,
    private _viewContainerRef: ViewContainerRef,
  ) {
    this.dialog = dialogRef;
  }

  ngOnInit() { }

  selectAddress(address: ILocation) {
    this.dialog.close(address);
  }
}